"use strict";

var React = require('react/addons');
var Tooltip = React.createFactory(require('./tooltip'));

module.exports = function(el, config) {
  React.render(Tooltip(config), el);
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/tooltip/index.js
 **/